import React, { FC, ReactNode } from 'react';

import { AccordionSummary, AccordionDetails, Divider } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { isMobile } from 'react-device-detect';

import Tooltip from '../Tooltip';
import { AccordionCardStyled } from './GroupInvitationAccordion.Styles';
import { TSectionKey } from '../Tooltip/Utils/TooltipsTexts';

interface IProps {
  children: ReactNode;
  sectionKey: TSectionKey;
  title: string;
  className?: string;
}

const GroupInvitationAccordion: FC<IProps> = props => {
  const { children, sectionKey, title, className } = props;

  return (
    <AccordionCardStyled defaultExpanded={!isMobile} className={className}>
      <AccordionSummary
        className="accordion-summary"
        expandIcon={isMobile ? <ExpandMoreIcon /> : undefined}
        aria-controls="panel1c-content"
        id="panel1c-header"
      >
        <h3 className="title-tooltip override">{title}</h3>

        <Tooltip classes={{ fab: 'tooltip-fab--shift-top-5' }} sectionKey={sectionKey} />
      </AccordionSummary>

      <Divider />

      <AccordionDetails className="accordion-details">{children}</AccordionDetails>
    </AccordionCardStyled>
  );
};

export default GroupInvitationAccordion;
